import script from "./DanhSachKhachHangTiemNang.vue?vue&type=script&setup=true&lang=js"
export * from "./DanhSachKhachHangTiemNang.vue?vue&type=script&setup=true&lang=js"

import "./DanhSachKhachHangTiemNang.vue?vue&type=style&index=0&id=2720579a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2720579a"]])

export default __exports__